import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import  Sidebar from "./Sidebar";
import Zoom from 'react-reveal/Zoom';


class NosPartenaires extends Component {
  render() {
    return (
    <div>   
   <div>   
    <section className="inner-intro bg-image overlay-dark  parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/branding/pmg5.jpg")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Green Agro Business</a>/<span>Partenaires</span>
                    </div>
                </div>
            </div>
        </section>








        <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
                <div className="row text-center inside_content partenaires_first">
                  <div className="col-md-3"><a href="https://www.isra.sn/" target="blank"><img src="/assets/img/logos/isra.png" alt="" className="part_logo citeiz" /></a></div>
                  <div className="col-md-3"><a href="https://societegenerale.sn/" target="blank"><img src="/assets/img/logos/sgbs.png" alt="" className="part_logo bank" /></a>
                    <h4 className="maison">La maison de la PME</h4>
                  </div>
                  <div className="col-md-3"><a href="https://www.orabank.net/fr" target="blank"><img src="/assets/img/logos/orabank.jpg" alt="" className="part_logo"/></a></div>
                  <div className="col-md-3"><a href="https://www.abcobourse.com/" target="blank"><img src="/assets/img/logos/abcobouse.jpg" alt="" className="part_logo"/></a></div>
                </div>
                <div className="row">
                  <div className="col-md-4"><img src="/assets/img/logos/ue.jpg" alt="" className="part_logo"/><br/><p className="union"><b>Union Européenne</b></p></div>
                  <div className="col-md-4"><a href="https://www.afd.fr/fr" target="blank"><img src="/assets/img/logos/Logo-AFD.jpg" alt="" className="part_logo afd" /></a></div>
                  <div className="col-md-4"><h4 className="program">Programme National de Biogaz <br/>PNB-SN</h4></div>


{/*
    <OwlCarousel
        className="owl-theme container"
        loop
        margin={10}
        row={1}
        nav
        autoplay= {true}
    
    >
    
    
        <div className="item"><a href="https://www.isra.sn/" target="blank"><h4><img src="/assets/img/logos/isra.png" alt="" className="isra" /></h4></a></div>
        <div className="item"><a href="https://societegenerale.sn/" target="blank"><h4><img src="/assets/img/logos/sgbs.png" alt="" className="caisse sgbs" /><p className="logo-subtitle">La Maison de la PME </p></h4></a></div>
        <div className="item"><a href="https://www.orabank.net/fr" target="blank"><h4> <img src="/assets/img/logos/orabank.jpg" alt="" className="ora"/></h4></a></div>
        <div className="item"><a href="https://www.abcobourse.com/" target="blank"><h4><img src="/assets/img/logos/abcobouse.jpg" alt="" className="ora"/></h4></a></div>
        <div className="item"><h4><img src="/assets/img/logos/ue.jpg" alt="" className="ue"/><p className="logo-subtitle"> Union Européenne</p></h4></div>
        <div className="item"><h4><p className="program">PNB-SN</p></h4></div>
        <div className="item"><a href="https://www.afd.fr/fr" target="blank"><h4><img src="/assets/img/logos/Logo-AFD.jpg" alt="" className="afd" /></h4></a></div>
      
     
    </OwlCarousel> */}
                </div>
                    

                </div>

                
                 
                   
                
                
            
        
        </section>
    {/*<section id="client-logos about" className="wow fadeIn ptb ptb-sm-80">
               <div className="container filigrane page_info">
                    <div className="row text-center inside_content">
                  <div className="col-md-12">
                      <h3><img src="/assets/img/leaf.png" className="leaf-sidebar"/> Ils nous font confiance</h3>
                <div className="row">
                        <div className="col-md-4">
                            <div className="item">
                                <div className="client-logo">
                                <a href="http://www.isra.sn/" target="blank">
                                    <img src="/assets/img/logos/isra.png" alt="" className="isra" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                             <div className="item">
                               <div className="client-logo">
                               <a href="http://www.cdc.sn/" target="blank">
                                   <img src="/assets/img/logos/cdcc.jpg" alt="" className="caisse" />
                                   </a>
                               </div>
                           </div>
                        </div>
                        <div className="col-md-4">
                           <div className="item">
                               <div className="client-logo">
                               <a href="https://www.orabank.net/fr/filiale/senegal" target="blank">
                                   <img src="/assets/img/logos/orabank.jpg" alt="" className="ora"/>
                                   </a>
                               </div>
                           </div>
                        </div>            
                    </div>
                    </div>
                    
                    </div>
                    </div>
            </section>*/}
    </div>
    </div>
    )
  }
}
export default NosPartenaires;


// WEBPACK FOOTER //
// ./src/components/partenaire.jsx